import { opportunitySyncService } from '@/services/opportunity-sync.service';
import axios from 'axios';

const initialState = () => ({
  opportunitySyncs: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getOpportunitySyncs({ commit }, { profileIds, opportunityIds, cancelToken }) {
    commit('GET_OPPORTUNITY_SYNCS');

    return opportunitySyncService.getOpportunitySyncs({ profileIds, opportunityIds, cancelToken }).then(
      (response) => {
        commit('SUCCESS_GET_OPPORTUNITY_SYNCS', { profileIds, opportunityIds, opportunitySyncs: response });
        return response;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR_GET_OPPORTUNITY_SYNCS', error);
          throw error;
        }
      },
    );
  },
  syncOpportunity({ commit }, { profileId, opportunityId, fieldValues }) {
    commit('SYNC_OPPORTUNITY');

    return opportunitySyncService.syncOpportunity({ profileId, opportunityId, fieldValues }).then(
      (response) => {
        commit('SUCCESS_SYNC_OPPORTUNITY', response);
        return response;
      },
      (error) => {
        commit('ERROR_SYNC_OPPORTUNITY', error);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_OPPORTUNITY_SYNCS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  // Several views share this list with different scopes: the opportunities page fetches a whole page of
  // opportunities while the details header and quotes page fetch a single one. Replacing the list let the
  // last caller wipe the others' entries (the kept-alive opportunities list then showed every row as never
  // synced after visiting a details page), so only the requested (profile, opportunity) pairs are refreshed
  // and everything else is kept.
  SUCCESS_GET_OPPORTUNITY_SYNCS(state, { profileIds, opportunityIds, opportunitySyncs }) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    const isRequested = (sync) => profileIds.includes(sync.profileId) && opportunityIds.includes(sync.opportunityId);
    state.opportunitySyncs = [...state.opportunitySyncs.filter((sync) => !isRequested(sync)), ...opportunitySyncs];
  },
  ERROR_GET_OPPORTUNITY_SYNCS(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
    // Keep the last known statuses: a failed refresh for one view must not blank the others' entries.
  },
  SYNC_OPPORTUNITY(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_SYNC_OPPORTUNITY(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR_SYNC_OPPORTUNITY(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
  },
};

const getters = {
  opportunitySyncs: (state) => state.opportunitySyncs,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunitySync = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
